import Head from "next/head";
import { make as LbBookmarks } from "../../src/leaderboards/LbBookmarks.bs";
import { lastPatch } from "common/src/Config.ts";

export default function Player() {
  return (
    <>
      <Head>
        <title>TFT bookmarked player leaderboards</title>
      </Head>
      <LbBookmarks />
    </>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {},
    revalidate: 3600,
  };
}
